import React from 'react';
import { getTotalBemClass } from 'components/scores';

const CustomEventLeaderboardScoreToParColumn = ({
    playerScoreToPar, playerScore, isPointsBased, hasBonusPoints
}) => {
    const playerDisplayScore = isPointsBased ? playerScore : playerScoreToPar;
    const toParClass = isPointsBased ? getTotalBemClass(playerScore > 0 ? -1 : null) : getTotalBemClass(playerDisplayScore);
    const scoreToPar = (playerDisplayScore === null || playerDisplayScore === undefined || playerDisplayScore === '') ? '-' : playerDisplayScore;

    return (
        <div className={`custom-event-leaderboard__cell custom-event-leaderboard__cell--hole ${hasBonusPoints && isPointsBased ? 'custom-event-leaderboard__cell--hole--points-based' : ''}`}>
            <div className="custom-event-leaderboard__label">
                {isPointsBased ? 'TOTAL' : 'PAR'}
            </div>
            <div className={`score-cell score-cell--${toParClass} score-cell--has-border`}>
                {scoreToPar}
            </div>
        </div>
    );
};

export default CustomEventLeaderboardScoreToParColumn;
